import * as React from 'react';
import { LibraryCard } from '../../../../../types/LibraryCard';
import { CategoryCard } from '../../../../../types/CategoriesCard';
import Categories from '../../../../Header/FindBook/Categroies/Categories';

interface Props {
	cards: LibraryCard[];
	setCollection: (id: number) => void;
	selectedCollection?: number;
}

const CategoriesWrapper: React.FC<Props> = props => {
	const categories = React.useMemo(() => {
		const categoriesArray: {
			id: number,
			name: string,
			count: number
		}[] = [];
		const categoriesCardMap: Map<number, CategoryCard> = new Map();

		props.cards.forEach(card => {
			if (categoriesCardMap.has(card.book.collection.id)) {
				const category = categoriesCardMap.get(card.book.collection.id);

				categoriesCardMap.set(
					card.book.collection.id,
					{
						...category,
						count: category.count + 1
					}
				);
			}
			else {
				categoriesCardMap.set(card.book.collection.id, {
					count: 1,
					category: card.book.collection as any,
					percent: 0
				});
			}
		});

		categoriesCardMap.forEach(value => {
			categoriesArray.push({
				id: value.category.id,
				name: value.category.name,
				count: value.count
			})
		});

		return categoriesArray;
	}, [props.cards]);

	return <Categories
		categories={categories}
		setCategory={id => props.setCollection(id as any)}
		removeCategory={() => props.setCollection(null)}
		selectedCategory={props.selectedCollection}
	/>;
};

export default CategoriesWrapper;